import React, { useState, useEffect } from 'react';
import { useAgent } from '../../../../context/agent/AgentContext';
import defaultLogoImg from '../../../../assets/Trrip_logo/sample_company_logo.png';
import SampleVoucherCard from './sections/SampleVoucherCard';
import TravellerAppView from './sections/TravellerAppView';
import SampleVoucherPdfModal from './sections/SampleVoucherPdfModal';

const SampleVoucherSection = ({
  onOpenPreviewRef,
  isPreviewOpen: controlledIsPreviewOpen,
  onPreviewChange
}) => {
  const { userData, agent } = useAgent();
  const [internalPreviewOpen, setInternalPreviewOpen] = useState(false);

  const isPreviewOpen = controlledIsPreviewOpen !== undefined ? controlledIsPreviewOpen : internalPreviewOpen;
  const setIsPreviewOpen = React.useCallback(
    (val) => {
      setInternalPreviewOpen(val);
      onPreviewChange?.(val);
    },
    [onPreviewChange]
  );

  // Expose setIsPreviewOpen to parent via ref callback
  useEffect(() => {
    if (onOpenPreviewRef) {
      onOpenPreviewRef.current = (val = true) => setIsPreviewOpen(val);
    }
  }, [onOpenPreviewRef, setIsPreviewOpen]);

  const companyName = userData?.company_name || userData?.name || 'YOUR COMPANY NAME HERE';
  const rawLogo =
    agent?.company_logo ||
    agent?.logo ||
    userData?.company_logo ||
    userData?.logo ||
    userData?.agent?.company_logo;
  const effectiveLogo = (rawLogo && !String(rawLogo).includes('4triplogo')) ? rawLogo : defaultLogoImg;

  return (
    <div className="w-full bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-7 xl:p-8 border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
      {/* Main Grid: Stacked on mobile & tablet/laptop (<1280px), 2-Column on large desktop (>=1280px) */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 xl:gap-8 items-center xl:items-start">
        {/* Left Sub-Section: Sample Voucher Ticket Card */}
        <SampleVoucherCard
          effectiveLogo={effectiveLogo}
          companyName={companyName}
          onOpenPreview={() => setIsPreviewOpen(true)}
        />

        {/* Right Sub-Section: Traveller's App View (Mobile Mockup) */}
        <TravellerAppView />
      </div>

      {/* Sample Voucher PDF Preview Modal */}
      <SampleVoucherPdfModal
        isOpen={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        effectiveLogo={effectiveLogo}
        companyName={companyName}
        agent={agent}
        userData={userData}
      />
    </div>
  );
};

export default SampleVoucherSection;
